var widget_default = {
  "card": "uMhWF",
  "link": "vRFov",
  "container": "_34djP",
  "image": "aZbKl",
  "right": "i-Z92",
  "cardLayout": "OMhTP",
  "content": "OyBO9",
  "title": "_5aUW8",
  "subtitle": "Gm7Ld",
  "button": "pX8K9",
  "button_disabled": "KAFeO",
  "buttonText": "j0gTP",
  "slimLayout": "-PFvI",
  "contentText": "fm5xT"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
